{
  "version": 1,
  "asset_id": "3773fa94-3f84-40e0-bc2e-69ce2f143f99",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/3773fa94-3f84-40e0-bc2e-69ce2f143f99/antiquing-dry-poster.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/3773fa94-3f84-40e0-bc2e-69ce2f143f99/antiquing-dry-poster.webp",
  "original_filename": "antiquing-dry-poster.webp",
  "size": 64046,
  "content_type": "image/webp",
  "created_at": "2026-09-11T23:20:36Z"
}
